import React from 'react';
import '../css/D2H.css';
import Cookies from 'js-cookie';
import _ from 'lodash';
import Sorting from './Sorting';
// import SearchBar from 'material-ui-search-bar'
import Loader from 'react-loader-spinner';
import * as ActionTypes from '../actions/types';
import { connect } from 'react-redux';
// import createHistory from 'history/createBrowserHistory';
;



// d2h pages of ai
class D2H extends React.Component{
  constructor(props){
    super(props);
    this.state = {
      logData: [],
      sortedType: '',
      searchValue: '', 
      actualData: [],
      searchActive: false,
    loadSpinner: true,
    }
  }
  componentDidMount(){
    //table for ai testing of channel list
    var tokenStored = localStorage.getItem('token');
    tokenStored = `Token ${tokenStored}`
    var headers = {
      'Content-Type': 'application/json',
      "Access-Control-Allow-Origin": "*",
      'X-CSRFToken': localStorage.getItem('csrftoken'),
      'Authorization': tokenStored
  }

    fetch('/cloud/d2htabledata/' ,{
            method: "GET",
            headers: headers,
        })
           .then(response => {
              if(response.status===403){
                localStorage.removeItem('token');
                localStorage.removeItem('csrftoken');
                localStorage.removeItem('auth');
                // const history = createHistory({forceRefresh: true})
                window.location.href = '/session-timeout'
              }else{
                  return response.json()}
              })
  .then(data => {
    console.log(data)
    this.setState({
      logData: data,
      actualData: data
    }, ()=>{
      this.setState({
        loadSpinner: false
      })
    })
  })
  .catch((err)=>{
    console.log(err)

  })
  }

  restoreData = (data) => {
    this.setState({
      logData: data
    })
 }
   sortingFunc = (type,searchValue) => {
     if(this.state.sortedType!==type && type!=='search' ){
       this.setState({
         sortedType: type
       })
     Sorting(this.restoreData, type, this.state.logData);
     }else if(type==='search'){
       type='search';
       Sorting(this.restoreData, type, this.state.actualData,searchValue);
     }else{
       type='reverse';
     Sorting(this.restoreData, type, this.state.logData);
     }
   }
 
    render(){
        return (
          <div className="d2h">
                     { this.props.redux.auth.searchBarShow ?  <div className='animated animated-duration-custom slideInDown pb-3 mx-4'>
                        <IntegrationReactSelectNew  autoFocus
                                    value={this.state.searchValue}
                                    onChange={(e)=>{                  
                                      this.setState({
                                        searchValue: e
                                      },()=>{
                                        this.sortingFunc('search',this.state.searchValue)
                                      })
                                    }
                                  }  
                                  onRequestSearch={() => this.sortingFunc('search',this.state.searchValue)}
                                  /></div> : null}
            <h3 className="ai-heading  dashboard-ai-heading ml-5">Channel User Data</h3>
           {!this.state.loadSpinner ?  <div className="si-list">
           <div className="outer">
             <div className="flex">           
                <table className="table table-striped table-fixed">
                  <thead className="tableHeaderColor">
                    <tr>
                    <th scope="col">
                    {/* <i class={`fas ${this.state.searchActive ? "fa-angle-up" : "fa-angle-down"} fa-2x mr-2`} 
                      onClick={()=>{
                        this.setState({
                          searchActive: !this.state.searchActive
                        })}
                      }
                      ></i> */}
                    AI ID<i class="fas fa-sort pointer"  onClick={(e)=>{this.sortingFunc('ai_id')}}></i> </th>
                      <th scope="col">OKAS Box No <i class="fas fa-sort pointer"  onClick={(e)=>{this.sortingFunc('roomId')}}></i></th>
                      <th scope="col">User Name<i class="fas fa-sort pointer"  onClick={(e)=>{this.sortingFunc('userId')}}></i></th>
                      <th scope="col">Date <i class="fas fa-sort pointer"  onClick={(e)=>{this.sortingFunc('date')}}></i></th>
                      <th scope="col">Time To <i class="fas fa-sort pointer"  onClick={(e)=>{this.sortingFunc('in_time')}}></i></th>
                      <th scope="col">Time Till <i class="fas fa-sort pointer"  onClick={(e)=>{this.sortingFunc('out_time')}}></i></th>
                      <th scope="col">Duration <i class="fas fa-sort pointer"  onClick={(e)=>{this.sortingFunc('duration')}}></i></th>
                      <th scope="col">Genre <i class="fas fa-sort pointer"  onClick={(e)=>{this.sortingFunc('genre')}}></i></th>
                      <th scope="col">Channel <i class="fas fa-sort pointer"  onClick={(e)=>{this.sortingFunc('channel_name')}}></i></th>
                      <th scope="col">Room Type <i class="fas fa-sort pointer"  onClick={(e)=>{this.sortingFunc('roomtype')}}></i></th>
                    </tr>
                  </thead>
                  <tbody>
                  {this.state.searchActive ? <tr>
                      <td colSpan={9}>
                      <div className="col-12">
                      <IntegrationReactSelectNew  autoFocus
                                    value={this.state.searchValue}
                                    onChange={(e)=>{                  
                                      this.setState({
                                        searchValue: e
                                      },()=>{
                                        this.sortingFunc('search',this.state.searchValue)
                                      })
                                    }
                                  }  
                                  onRequestSearch={() => this.sortingFunc('search',this.state.searchValue)}
                                  />
                     </div>
                      </td>
                    </tr> : null}
                    {this.state.logData.map((e, index)=>{
                      return (
                        <tr key={index}  className="some-hover">
                          <th scope="row">{e.ai_id}</th>
                          <th scope="row">{e.roomId}</th>
                          <td>{e.userId}</td>
                          <td>{e.date}</td>
                          <td>{e.in_time}</td>
                          <td>{e.out_time}</td>
                          <td>{e.duration}</td>
                          <td>{e.genre}</td>
                          <td>{e.channel_id}/{e.channel_name}</td>
                          <td>{e.roomtype}</td>
                        </tr>
                      );
                    })}
                  </tbody>.
                </table>
          </div>
        </div>
          </div> :  <div className="spinnerLoad" style={{'marginTop': '12%', 'marginLeft': '45%'}}>
          <Loader 
	     type="Bars"
	     color="#f89500"
	     height="75"	
	     width="75"
       />    
          </div>}
          </div>
        );
    }
}
const mapStateToProps = state  => {
  return {
    redux: state,
  };
};



const mapDispatchToProps = dispatch => {
  return {
    searchBarActivate: (data) => dispatch({type: ActionTypes.SEARCHBAR, data: data }),
  };
};


export default connect(mapStateToProps, mapDispatchToProps) (D2H);